var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pageView"},[_c('PageHeader'),_c('div',{staticClass:"mainContent"},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }